import { render, staticRenderFns } from "./AddProcesses.vue?vue&type=template&id=4aeb0fa3"
import script from "./AddProcesses.vue?vue&type=script&lang=js"
export * from "./AddProcesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports